module.exports = __webpack_public_path__ + "static/img/12.79e91cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/12.jpg
// module id = XCfw
// module chunks = 1